class DlPreBlackFridaySubscribeM extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('dl-pre-black-friday-subscribe-m', DlPreBlackFridaySubscribeM);

class DlPreBlackFridayProgressM extends HTMLElement {
  constructor() {
    super();
    this.shineCounts = new Map(); // Track shine animation counts for each card
    this.observer = null; // Intersection Observer instance
    this.stageItems = null;
    this.mobileStageItems = null;
    this.markers = null;
    this.mobileMarkers = null;
  }

  connectedCallback() {
    this.currentSubscribers = parseInt(this.getAttribute('data-subscribers-num')) || 0;
    this.stageTargets = [
      parseInt(this.getAttribute('data-stage-target-1')) || 0,
      parseInt(this.getAttribute('data-stage-target-2')) || 0,
      parseInt(this.getAttribute('data-stage-target-3')) || 0
    ];

    this.initProgressBar();
    this.initStageItem();
    this.initShineEffect();
  }

  disconnectedCallback() {
    // Clean up observer to prevent memory leaks
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  /**
   * Initialize progress bar
   */
  initProgressBar() {
    this.updateProgressBar();
  }

  /**
   * Initialize stage items for both desktop and mobile
   */
  initStageItem() {
    this.cacheStageElements();
    this.updateStageItems();
    this.updateMarkers();
  }

  /**
   * Cache stage elements to avoid repeated DOM queries
   */
  cacheStageElements() {
    this.stageItems = this.querySelectorAll('.dl-pre-black-friday-progress-m-item');
    this.mobileStageItems = this.querySelectorAll('.dl-mobile-reward-card');
    this.markers = this.querySelectorAll('.dl-progress-marker');
    this.mobileMarkers = this.querySelectorAll('.dl-mobile-progress-marker');
  }

  /**
   * Update stage items based on current subscriber count
   */
  updateStageItems() {
    // Update desktop cards
    this.stageItems.forEach(item => {
      this.updateStageItem(item, 'dl-pre-black-friday-progress-m-item-active', '.dl-pre-black-friday-progress-m-item-content-desc');
    });

    // Update mobile cards
    this.mobileStageItems.forEach(item => {
      this.updateStageItem(item, 'dl-mobile-reward-card-active', '.dl-mobile-reward-card-desc');
    });
  }

  /**
   * Update individual stage item
   */
  updateStageItem(item, activeClass, descSelector) {
    const subscribeNum = parseInt(item.getAttribute('data-subscriber-num')) || 0;
    const stageActiveDesc = item.getAttribute('data-stage-active-desc');
    const stageRewardType = item.getAttribute('data-stage-reward-type');
    const subscribeSuccessCode = item.getAttribute('data-subscribe-success-code');
    const isSubscribed = localStorage.getItem('dl_bf_is_subscribed') === 'true';
    if (this.currentSubscribers >= subscribeNum) {
      item.classList.add(activeClass);
      const descElement = item.querySelector(descSelector);
      if (descElement && stageActiveDesc) {
        descElement.textContent = stageRewardType == 'percentage' && isSubscribed ? subscribeSuccessCode : stageActiveDesc;
      }
    } else {
      item.classList.remove(activeClass);
    }
  }

  /**
   * Update progress markers
   */
  updateMarkers() {
    // Update desktop markers
    this.markers.forEach(marker => {
      this.updateMarker(marker);
    });

    // Update mobile markers
    this.mobileMarkers.forEach(marker => {
      this.updateMarker(marker);
    });
  }

  /**
   * Update individual marker
   */
  updateMarker(marker) {
    const stage = parseInt(marker.getAttribute('data-stage-num')) || 0;
    if (this.currentSubscribers >= stage) {
      marker.classList.add('active');
    } else {
      marker.classList.remove('active');
    }
  }

  /**
   * Update progress bar for both desktop and mobile
   */
  updateProgressBar() {
    const progressData = this.calculateProgressData();
    this.updateDesktopProgress(progressData);
    this.updateMobileProgress(progressData);
    this.updateProgressText(progressData);
  }

  /**
   * Calculate progress data
   */
  calculateProgressData() {
    let currentStage = 0;
    let progressPercentage = 0;

    // Find the highest achieved stage
    for (let i = 0; i < this.stageTargets.length; i++) {
      if (this.currentSubscribers >= this.stageTargets[i]) {
        currentStage = i + 1;
      } else {
        break;
      }
    }

    // Calculate progress percentage for current stage
    if (currentStage === 0) {
      // Not reached first stage
      progressPercentage = (this.currentSubscribers / this.stageTargets[0]) * 100;
    } else if (currentStage < this.stageTargets.length) {
      // Reached a stage, calculate progress to next stage
      const prevTarget = currentStage === 1 ? 0 : this.stageTargets[currentStage - 2];
      const currentTarget = this.stageTargets[currentStage - 1];
      const nextTarget = this.stageTargets[currentStage];
      progressPercentage = ((this.currentSubscribers - currentTarget) / (nextTarget - currentTarget)) * 100;
    } else {
      // Reached highest stage
      progressPercentage = 100;
    }

    return { currentStage, progressPercentage };
  }

  /**
   * Update desktop progress bar
   */
  updateDesktopProgress(progressData) {
    const progressFill = this.querySelector('.dl-progress-bar-fill');
    if (!progressFill) return;

    const { currentStage, progressPercentage } = progressData;

    // Marker positions based on CSS (as percentages of progress bar width)
    // Progress bar total width is 78.125vw (container max-width)
    // First marker: 13.75vw / 78.125vw = 17.6%
    // Second marker: 31.67vw / 78.125vw = 40.54%  
    // Third marker: 53.75vw / 78.125vw = 68.8%
    const markerPositions = [17.6, 40.54, 68.8];

    let totalWidth;

    if (currentStage === 0) {
      // Not reached first stage - progress from 0 to first marker
      totalWidth = (progressPercentage / 100) * markerPositions[0];
    } else if (currentStage === 1) {
      // Reached first stage - progress from first marker to second marker
      totalWidth = markerPositions[0] + (progressPercentage / 100) * (markerPositions[1] - markerPositions[0]);
    } else if (currentStage === 2) {
      // Reached second stage - progress from second marker to third marker
      totalWidth = markerPositions[1] + (progressPercentage / 100) * (markerPositions[2] - markerPositions[1]);
    } else {
      // Reached all stages
      totalWidth = markerPositions[2];
    }

    progressFill.style.width = `${Math.min(totalWidth, 100)}%`;
  }

  /**
   * Update mobile progress bar
   */
  updateMobileProgress(progressData) {
    const mobileProgressFill = this.querySelector('.dl-mobile-progress-fill');
    if (!mobileProgressFill) return;

    const { currentStage, progressPercentage } = progressData;

    // Marker positions based on CSS (as percentages of progress bar height)
    // Progress bar total height is 131.73vw
    // First marker: 34.13vw / 131.73vw = 25.91%
    // Second marker: 68.27vw / 131.73vw = 51.83%
    // Third marker: 102.4vw / 131.73vw = 77.73%
    const markerPositions = [25.91, 51.83, 77.73];

    let totalHeight;

    if (currentStage === 0) {
      // Not reached first stage - progress from 0 to first marker
      totalHeight = (progressPercentage / 100) * markerPositions[0];
    } else if (currentStage === 1) {
      // Reached first stage - progress from first marker to second marker
      totalHeight = markerPositions[0] + (progressPercentage / 100) * (markerPositions[1] - markerPositions[0]);
    } else if (currentStage === 2) {
      // Reached second stage - progress from second marker to third marker
      totalHeight = markerPositions[1] + (progressPercentage / 100) * (markerPositions[2] - markerPositions[1]);
    } else {
      // Reached all stages
      totalHeight = markerPositions[2];
    }

    mobileProgressFill.style.height = `${Math.min(totalHeight, 100)}%`;
  }

  /**
   * Update progress text
   */
  updateProgressText(progressData) {
    const { currentStage } = progressData;

    // Update desktop text
    const progressText = document.querySelectorAll('.dl-progress-current');
    if (progressText.length > 0) {
      const remaining = this.calculateRemainingSubscribers(currentStage);
      progressText.forEach(text => {
        text.textContent = Math.max(0, remaining);
      });
    }

    // Update mobile text
    const mobileProgressText = document.querySelectorAll('.dl-mobile-progress-current');
    if (mobileProgressText) {
      const remaining = this.calculateRemainingSubscribers(currentStage);
      mobileProgressText.forEach(text => {
        text.textContent = Math.max(0, remaining);
      });
    }
  }

  /**
   * Calculate remaining subscribers to next stage
   */
  calculateRemainingSubscribers(currentStage) {
    if (currentStage === 0) {
      return this.stageTargets[0] - this.currentSubscribers;
    } else if (currentStage < this.stageTargets.length) {
      return this.stageTargets[currentStage] - this.currentSubscribers;
    } else {
      return 0;
    }
  }



  /**
   * Initialize shine effect for active cards
   */
  initShineEffect() {
    this.addShineElements();
    this.setupIntersectionObserver();
  }

  /**
   * Add shine elements to active cards
   */
  addShineElements() {
    // Add shine to active desktop cards
    this.stageItems.forEach((item, index) => {
      if (item.classList.contains('dl-pre-black-friday-progress-m-item-active')) {
        this.addShineElement(item);
        this.shineCounts.set(index, 0);
      }
    });

    // Add shine to active mobile cards
    this.mobileStageItems.forEach((item, index) => {
      if (item.classList.contains('dl-mobile-reward-card-active')) {
        this.addShineElement(item);
        this.shineCounts.set(`mobile-${index}`, 0);
      }
    });
  }

  /**
   * Add shine element to a card
   */
  addShineElement(item) {
    const shineElement = document.createElement('div');
    shineElement.className = 'dl-pre-black-friday-progress-m-item-shine';
    item.style.position = 'relative';
    item.appendChild(shineElement);
  }

  /**
   * Setup Intersection Observer for shine effects
   */
  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // Trigger when 50% of card is visible
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.handleCardIntersection(entry.target);
        }
      });
    }, options);

    // Observe all desktop cards
    this.stageItems.forEach(item => {
      this.observer.observe(item);
    });

    // Observe all mobile cards
    this.mobileStageItems.forEach(item => {
      this.observer.observe(item);
    });
  }

  /**
   * Handle card intersection for shine effect
   */
  handleCardIntersection(item) {
    let index;
    let isMobile = false;

    // Determine if it's desktop or mobile card
    if (item.classList.contains('dl-pre-black-friday-progress-m-item')) {
      index = Array.from(this.stageItems).indexOf(item);
    } else if (item.classList.contains('dl-mobile-reward-card')) {
      index = Array.from(this.mobileStageItems).indexOf(item);
      isMobile = true;
    }

    // Only trigger shine effect for active cards
    if (item.classList.contains('dl-pre-black-friday-progress-m-item-active') ||
      item.classList.contains('dl-mobile-reward-card-active')) {
      const key = isMobile ? `mobile-${index}` : index;
      this.triggerShineEffect(item, key);
    }
  }

  /**
   * Trigger shine effect for a card
   */
  triggerShineEffect(item, index) {
    const currentCount = this.shineCounts.get(index) || 0;

    // Stop if already executed 3 times
    if (currentCount >= 3) {
      return;
    }

    const shineElement = item.querySelector('.dl-pre-black-friday-progress-m-item-shine');
    if (!shineElement) return;

    // Increment count
    this.shineCounts.set(index, currentCount + 1);

    // Execute shine animation
    shineElement.classList.remove('animate');
    // Force reflow to reset animation
    void shineElement.offsetWidth;
    shineElement.classList.add('animate');

    // Continue animation if not reached 3 times
    setTimeout(() => {
      if (this.shineCounts.get(index) < 3) {
        this.triggerShineEffect(item, index);
      }
    }, 1500); // Wait for animation to complete
  }

  /**
   * Public method: Update subscriber count
   */
  updateSubscribers(count) {
    this.currentSubscribers = count;
    this.updateProgressBar();
  }
}
customElements.define('dl-pre-black-friday-progress-m', DlPreBlackFridayProgressM);

class DlBfNewsletterM extends HTMLElement {
  constructor() {
    super();
    this.form = null;
  }

  connectedCallback() {
    this.initForm();
  }

  /**
   * Initialize newsletter form
   */
  initForm() {
    this.form = this.querySelector('#BlackFridayForm');
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  /**
   * Handle form submission
   */
  handleSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const button = form.querySelector('button');
    try {
      const emailInput = form.querySelector('input[name="contact[email]"]');
      const email = emailInput?.value?.trim();
      button.classList.add('loading');
      button.setAttribute('disabled', true);
      button.setAttribute('aria-disabled', true);
      button.querySelector('.loading__spinner').classList.remove('hidden');
      if (!email) {
        console.warn('No email provided');
        return;
      }
      const DlPreBlackFridayProgress = document.querySelector('dl-pre-black-friday-progress-m');
      DLPixelH.identify(email);
      DlPreBlackFridayProgress.currentSubscribers = DlPreBlackFridayProgress.currentSubscribers + 1;
      DLPixelH.setUserProperty('current_subscribers_num', DlPreBlackFridayProgress.currentSubscribers);
      DLPixelH.setUserProperty('current_stage', DlPreBlackFridayProgress.calculateProgressData().currentStage);
      DLPixelH.capture('pre_black_friday_subscribe', {
        subscribe_email: email,
        subscribe_from: form.id,
        current_subscribers_num: DlPreBlackFridayProgress.currentSubscribers,
        current_stage: DlPreBlackFridayProgress.calculateProgressData().currentStage
      });
      // Save email to localStorage
      this.saveEmailToLocalStorage(email);
      // Set form submission flag
      localStorage.setItem('dl_bf_form_submitted', 'true');

      if (typeof fbq === 'function') {
        fbq('track', 'Lead');
      }
    } catch (error) {
      console.error('Error handling form submission:', error);
      button.classList.remove('loading');
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  /**
   * Save email to localStorage with error handling
   */
  saveEmailToLocalStorage(email) {
    try {
      localStorage.setItem('dl_bf_blackfriday_email', email);
    } catch (error) {
      console.error('Error saving email to localStorage:', error);
    }
  }
}
customElements.define('dl-bf-newsletter-m', DlBfNewsletterM);

class DlBfNewsletterSuccessPopM extends HTMLElement {
  constructor() {
    super();
    this.subscribersNum = this.getAttribute('data-subscribers-num');
    this.stageTargets = [
      this.getAttribute('data-stage-target-1'),
      this.getAttribute('data-stage-target-2'),
      this.getAttribute('data-stage-target-3')
    ];
    this.stageRewards = [
      this.getAttribute('data-stage-reward-1'),
      this.getAttribute('data-stage-reward-2'),
      this.getAttribute('data-stage-reward-3')
    ];
  }

  connectedCallback() {
    this.initPopup();
    this.setupEventListeners();
  }

  initPopup() {
    // 检查用户是否已订阅
    const isSubscribed = localStorage.getItem('dl_bf_is_subscribed') === 'true';
    if (isSubscribed) {
      // 如果已订阅，直接切换显示状态
      this.toggleSubscriptionState();
    } else if (this.shouldShowPopup()) {
      // 如果未订阅但满足弹窗条件，显示弹窗
      this.createPopupHTML();
      this.showPopup();
    }

    // 为已存在的订阅成功分享按钮添加事件监听
    this.setupSubscribedShareButton();
  }

  shouldShowPopup() {
    // 检查URL是否包含订阅成功参数
    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;
    const isSubscriptionSuccess = hash === '#BlackFridayForm';

    if (!isSubscriptionSuccess) {
      return false;
    }

    // 检查用户是否真正提交过表单
    const formSubmitted = localStorage.getItem('dl_bf_form_submitted') === 'true';
    if (!formSubmitted) {
      return false;
    }

    // 检查是否已经显示过弹窗
    const hasShownPopup = localStorage.getItem('dl_bf_popup_shown') === 'true';
    if (hasShownPopup) {
      return false;
    }

    // 检查邮箱是否匹配
    const currentEmail = this.getCurrentUserEmail();
    const blackfridayEmail = localStorage.getItem('dl_bf_blackfriday_email');

    if (currentEmail && blackfridayEmail && currentEmail === blackfridayEmail) {
      return false;
    }

    return true;
  }

  getCurrentUserEmail() {
    // 尝试从页面中获取当前用户邮箱
    const emailInput = document.querySelector('input[name="contact[email]"]');
    return emailInput ? emailInput.value : null;
  }

  getCurrentReward() {
    // 根据当前订阅者数量获取对应的奖励
    const currentSubscribers = parseInt(this.subscribersNum);
    const stage1 = parseInt(this.stageTargets[0]);
    const stage2 = parseInt(this.stageTargets[1]);
    const stage3 = parseInt(this.stageTargets[2]);

    if (currentSubscribers >= stage3) {
      return this.stageRewards[2];
    } else if (currentSubscribers >= stage2) {
      return this.stageRewards[1];
    } else if (currentSubscribers >= stage1) {
      return this.stageRewards[0];
    }
    return this.stageRewards[0]; // 默认返回第一阶段奖励
  }

  getCurrentThreshold() {
    // 根据当前订阅者数量获取对应的门槛
    const currentSubscribers = parseInt(this.subscribersNum);
    const stage1 = parseInt(this.stageTargets[0]);
    const stage2 = parseInt(this.stageTargets[1]);
    const stage3 = parseInt(this.stageTargets[2]);

    if (currentSubscribers >= stage3) {
      return this.getAttribute('data-stage-reward-3-threshold') || '450';
    } else if (currentSubscribers >= stage2) {
      return this.getAttribute('data-stage-reward-2-threshold') || '250';
    } else if (currentSubscribers >= stage1) {
      return this.getAttribute('data-stage-reward-1-threshold') || '100';
    }
    return this.getAttribute('data-stage-reward-1-threshold') || '100'; // 默认返回第一阶段门槛
  }

  getNextStageReward(currentSubscribers) {
    // 根据当前订阅者数量获取下一阶段的奖励
    const stage1 = parseInt(this.stageTargets[0]);
    const stage2 = parseInt(this.stageTargets[1]);
    const stage3 = parseInt(this.stageTargets[2]);

    if (currentSubscribers >= stage3) {
      // 已达到最高阶段，显示最高奖励
      return this.stageRewards[2];
    } else if (currentSubscribers >= stage2) {
      // 已达到第二阶段，下一阶段是第三阶段
      return this.stageRewards[2];
    } else if (currentSubscribers >= stage1) {
      // 已达到第一阶段，下一阶段是第二阶段
      return this.stageRewards[1];
    } else {
      // 未达到第一阶段，下一阶段是第一阶段
      return this.stageRewards[0];
    }
  }

  createPopupHTML() {
    // 获取配置文案
    const popupTitle = this.getAttribute('data-popup-title') || `You're our ${this.subscribersNum}th subscriber!`;
    let popupDescription = this.getAttribute('data-popup-description') || 'Enjoy $10 off orders of $100 or more. Want more savings? Invite your friends to subscribe and let\'s reach the next goal!';
    const copySuccessText = this.getAttribute('data-copy-success-text') || 'The link is copied and ready to share.';
    const shareText = this.getAttribute('data-share-text') || 'Share With Friends';
    // 处理标题中的变量替换
    const processedTitle = popupTitle.replace(/#s#/g, this.subscribersNum);

    // 检查是否达到第一阶段门槛
    const currentSubscribers = parseInt(this.subscribersNum);
    const stage1 = parseInt(this.getAttribute('data-stage-target-1'));

    // 如果未达到第一阶段，使用距离下一阶段的文案
    if (currentSubscribers < stage1) {
      const nextRewardDesc = this.getAttribute('data-next-reward-desc');
      const remainingSubscribers = stage1 - currentSubscribers;
      if (nextRewardDesc) {
        // 获取下一阶段的奖励金额
        const nextReward = this.getNextStageReward(currentSubscribers);
        popupDescription = nextRewardDesc.replace('#s#', remainingSubscribers).replace('#r#', nextReward);
      }
    } else {
      // 处理描述中的变量替换
      popupDescription = popupDescription.replace(/#s#/g, this.getCurrentReward());
      popupDescription = popupDescription.replace(/#t#/g, this.getCurrentThreshold());
    }

    const processedDescription = popupDescription;

    const popupHTML = `
      <div class="dl-bf-newsletter-success-popup-overlay">
        <div class="dl-bf-newsletter-success-popup">
          <button class="dl-bf-newsletter-success-popup-close" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19.0786 5.18551L4.93502 19.3291" stroke="black" stroke-width="1.5"/>
              <path d="M4.93502 5.18551L19.0786 19.3291" stroke="black" stroke-width="1.5"/>
            </svg>
          </button>
          <div class="dl-bf-newsletter-success-popup-content">
            <div class="dl-bf-newsletter-success-popup-content-inner">
              <div class="dl-bf-newsletter-success-popup-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <circle cx="32.0002" cy="32.0007" r="24.6667" stroke="#0CAC39" stroke-width="4"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M48.0949 24.0647L30.8146 41.3452C29.2499 42.9099 26.7121 42.9069 25.1511 41.3385L15.9023 32.046L18.7374 29.2243L27.9862 38.5168L45.2665 21.2363L48.0949 24.0647Z" fill="#0CAC39"/>
                </svg>
              </div>
              <h2 class="dl-bf-newsletter-success-popup-title">${processedTitle}</h2>
              <p class="dl-bf-newsletter-success-popup-description">
                ${processedDescription}
              </p>
            </div>
            <button class="dl-bf-newsletter-success-popup-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path d="M12.5001 5H4.50012V19H20.5001V12.5H22.5001V19C22.5001 20.1046 21.6047 21 20.5001 21H4.50012C3.39555 21 2.50012 20.1046 2.50012 19V5C2.50012 3.89543 3.39555 3 4.50012 3H12.5001V5ZM15.5001 5V3H20.5001C21.6047 3 22.5001 3.89543 22.5001 5V9.5H20.5001V6.41L11.8891 15.021L10.4751 13.6065L19.0816 5H15.5001Z" fill="white"/>
              </svg>
              ${shareText}
            </button>
          </div>
        </div>
      </div>
    `;

    this.innerHTML = popupHTML;

    // 保存复制成功文案到实例变量
    this.copySuccessText = copySuccessText;
  }

  showPopup() {
    const popup = this.querySelector('.dl-bf-newsletter-success-popup-overlay');
    if (popup) {
      // 禁用body滚动
      document.body.style.overflow = 'hidden';

      popup.style.display = 'flex';
      // 添加动画效果
      setTimeout(() => {
        popup.classList.add('show');
      }, 10);
      // 设置状态标记，防止重复显示弹窗
      localStorage.setItem('dl_bf_popup_shown', 'true');
      localStorage.setItem('dl_bf_is_subscribed', 'true');
      // 滚动到订阅组件位置
      this.scrollToSubscribeComponent();

      // 切换订阅状态显示
      this.toggleSubscriptionState();

      // 更新进度条 - 手动将订阅者数量+1
      this.updateProgressAfterSubscription();

    }
  }

  toggleSubscriptionState() {
    // 隐藏订阅表单容器
    const newsletterContainer = document.querySelector('.dl-bf-newsletter-m-container');
    if (newsletterContainer) {
      newsletterContainer.style.display = 'none';
    }

    // 显示订阅成功状态
    const subscribedElement = document.querySelector('dl-bf-newsletter-subscribeed-m');
    if (subscribedElement) {
      subscribedElement.style.display = 'block';
      // 为订阅成功状态的分享按钮添加事件监听
      this.setupSubscribedShareButton();
    }
  }

  updateProgressAfterSubscription() {
    // 找到进度条组件
    const progressComponent = document.querySelector('dl-pre-black-friday-progress-m');
    if (progressComponent) {
      // 手动将订阅者数量+1
      const currentSubscribers = parseInt(progressComponent.getAttribute('data-subscribers-num'));
      const newSubscriberCount = currentSubscribers + 1;

      // 更新data属性
      progressComponent.setAttribute('data-subscribers-num', newSubscriberCount);

      // 更新组件内部的订阅者数量
      if (progressComponent.currentSubscribers !== undefined) {
        progressComponent.currentSubscribers = newSubscriberCount;

        // 重新初始化进度条和阶段项目
        progressComponent.initStageItem();
        progressComponent.updateProgressBar();
      }

      // 更新弹窗中的订阅者数量
      this.updatePopupSubscriberCount(newSubscriberCount);

      // 更新订阅成功状态的文案
      this.updateSubscriptionSuccessText(newSubscriberCount);

    }
  }

  updatePopupSubscriberCount(newCount) {
    // 更新弹窗标题中的订阅者数量
    const popupTitle = this.querySelector('.dl-bf-newsletter-success-popup-title');
    if (popupTitle) {
      // 获取原始标题模板
      const originalTitle = this.getAttribute('data-popup-title') || `You're our #s#th subscriber!`;
      const updatedTitle = originalTitle.replace(/#s#/g, newCount);
      popupTitle.textContent = updatedTitle;
    }

    // 更新弹窗描述内容
    const popupDescription = this.querySelector('.dl-bf-newsletter-success-popup-description');
    if (popupDescription) {
      const currentSubscribers = newCount;
      const stage1 = parseInt(this.getAttribute('data-stage-target-1'));
      const stage2 = parseInt(this.getAttribute('data-stage-target-2'));
      const stage3 = parseInt(this.getAttribute('data-stage-target-3'));

      // 如果未达到第一阶段，使用距离下一阶段的文案
      if (currentSubscribers < stage1) {
        const nextRewardDesc = this.getAttribute('data-next-reward-desc');
        const remainingSubscribers = stage1 - currentSubscribers;
        if (nextRewardDesc) {
          // 获取下一阶段的奖励金额
          const nextReward = this.getNextStageReward(currentSubscribers);
          const currency = this.getAttribute('data-currency') || '$';
          const rewardWithCurrency = currency == '€' ? nextReward + ' ' + currency : currency + nextReward;
          const updatedDescription = nextRewardDesc.replace('#s#', remainingSubscribers).replace('#r#', rewardWithCurrency);
          popupDescription.textContent = updatedDescription;
        }
      } else {
        // 已达到第一阶段或以上，显示当前阶段的奖励信息
        const currentReward = this.getCurrentRewardForCount(currentSubscribers);
        const currentThreshold = this.getCurrentThresholdForCount(currentSubscribers);
        const currency = this.getAttribute('data-currency') || '$';

        if (currentReward) {
          const rewardWithCurrency = currency == '€' ? currentReward + ' ' + currency : currency + currentReward;
          const thresholdWithCurrency = currency == '€' ? currentThreshold + ' ' + currency : currency + currentThreshold;

          // 获取订阅成功弹窗描述模板
          const successDesc = this.getAttribute('data-popup-description') || 'Enjoy #s# off orders of #t# or more. Want more savings? Invite your friends to subscribe and let\'s reach the next goal!';
          const updatedDescription = successDesc.replace(/#s#/g, rewardWithCurrency).replace(/#t#/g, thresholdWithCurrency);
          popupDescription.textContent = updatedDescription;
        }
      }
    }
  }

  updateSubscriptionSuccessText(newCount) {
    // 更新订阅成功状态的标题文案
    const successTitle = document.querySelector('dl-bf-newsletter-subscribeed-m .dl-pre-black-friday-subscribe-m-title');
    if (successTitle) {
      // 获取当前阶段的奖励
      const currentReward = this.getCurrentRewardForCount(newCount);
      if (currentReward) {
        // 获取货币符号
        const currency = this.getAttribute('data-currency') || '$';
        const rewardWithCurrency = currency == '€' ? currentReward + ' ' + currency : currency + currentReward;
        // 获取订阅成功描述模板
        const successDesc = this.getAttribute('data-subscribe-success-desc') || 'You\'ve got a #s# discount.';
        const updatedDesc = successDesc.replace('#s#', rewardWithCurrency);
        successTitle.textContent = updatedDesc;
      }
    }

    // 更新订阅成功状态的副标题文案
    const successSubTitle = document.querySelector('dl-bf-newsletter-subscribeed-m .dl-pre-black-friday-subscribe-m-sub-title');
    if (successSubTitle) {
      // 计算距离下一个目标的订阅人数
      const stage1 = parseInt(this.getAttribute('data-stage-target-1'));
      const stage2 = parseInt(this.getAttribute('data-stage-target-2'));
      const stage3 = parseInt(this.getAttribute('data-stage-target-3'));

      let remainingSubscribers = 0;
      let nextReward = '';

      if (newCount >= stage3) {
        // 已达到最高阶段，显示0
        remainingSubscribers = 0;
        nextReward = this.stageRewards[2];
      } else if (newCount >= stage2) {
        // 已达到第二阶段，距离第三阶段
        remainingSubscribers = stage3 - newCount;
        nextReward = this.stageRewards[2];
      } else if (newCount >= stage1) {
        // 已达到第一阶段，距离第二阶段
        remainingSubscribers = stage2 - newCount;
        nextReward = this.stageRewards[1];
      } else {
        // 未达到第一阶段，距离第一阶段
        remainingSubscribers = stage1 - newCount;
        nextReward = this.stageRewards[0];
      }

      // 获取距离下一阶段文案模板
      const nextRewardDesc = this.getAttribute('data-subscribe-next-reward-desc') || 'Just #s# more subscribers to save #r#!';
      const currency = this.getAttribute('data-currency') || '$';
      const rewardWithCurrency = currency == '€' ? nextReward + ' ' + currency : currency + nextReward;

      // 将数字包装在span标签中，与Liquid模板保持一致
      const spanStart = '<span class="dl-progress-current">';
      const spanEnd = '</span>';
      const remainingSubscribersWithSpan = spanStart + remainingSubscribers + spanEnd;

      const updatedDesc = nextRewardDesc.replace('#s#', remainingSubscribersWithSpan).replace('#r#', rewardWithCurrency);
      successSubTitle.innerHTML = updatedDesc;
    }
  }

  getCurrentRewardForCount(count) {
    // 根据当前订阅者数量获取对应的奖励
    const stage1 = parseInt(this.stageTargets[0]);
    const stage2 = parseInt(this.stageTargets[1]);
    const stage3 = parseInt(this.stageTargets[2]);

    if (count >= stage3) {
      return this.stageRewards[2];
    } else if (count >= stage2) {
      return this.stageRewards[1];
    } else if (count >= stage1) {
      return this.stageRewards[0];
    }
    return null; // 未达到任何阶段
  }

  getCurrentThresholdForCount(count) {
    // 根据当前订阅者数量获取对应的门槛
    const stage1 = parseInt(this.getAttribute('data-stage-target-1'));
    const stage2 = parseInt(this.getAttribute('data-stage-target-2'));
    const stage3 = parseInt(this.getAttribute('data-stage-target-3'));

    if (count >= stage3) {
      return this.getAttribute('data-stage-reward-3-threshold') || '450';
    } else if (count >= stage2) {
      return this.getAttribute('data-stage-reward-2-threshold') || '250';
    } else if (count >= stage1) {
      return this.getAttribute('data-stage-reward-1-threshold') || '100';
    }
    return this.getAttribute('data-stage-reward-1-threshold') || '100'; // 默认返回第一阶段门槛
  }

  setupSubscribedShareButton() {
    const shareButton = document.querySelector('.dl-bf-newsletter-subscribeed-reward-btn');
    if (shareButton && !shareButton.hasAttribute('data-event-bound')) {
      shareButton.addEventListener('click', () => {
        this.handleShare('pre_black_friday_share_btn_click');
      });
      // 标记已绑定事件，防止重复绑定
      shareButton.setAttribute('data-event-bound', 'true');
    }
  }

  scrollToSubscribeComponent() {
    // 查找订阅组件
    const subscribeComponent = document.querySelector('dl-pre-black-friday-subscribe-m');
    if (subscribeComponent) {
      subscribeComponent.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

  hidePopup() {
    const popup = this.querySelector('.dl-bf-newsletter-success-popup-overlay');
    if (popup) {
      popup.classList.remove('show');
      const email = localStorage.getItem('dl_bf_blackfriday_email');
      DLPixelH.capture('pre_black_friday_pop_close_btn_click', {
        subscribe_email: email,
        current_subscribers_num: parseInt(this.subscribersNum) + 1
      });
      setTimeout(() => {
        popup.style.display = 'none';
        // 恢复body滚动
        document.body.style.overflow = '';
      }, 300);
    }
  }

  setupEventListeners() {
    // 关闭按钮事件
    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('dl-bf-newsletter-success-popup-overlay')) {
        this.hidePopup();
      }
    });
    this.querySelector('.dl-bf-newsletter-success-popup-close')?.addEventListener('click', () => {
      this.hidePopup();
    });

    // 分享按钮事件
    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('dl-bf-newsletter-success-popup-button') ||
        e.target.closest('.dl-bf-newsletter-success-popup-button')) {
        this.handleShare('pre_black_friday_pop_share_btn_click');
      }
    });
  }

  handleShare(eventName) {
    // 获取不带参数的URL
    const baseUrl = window.location.origin + window.location.pathname;
    const email = localStorage.getItem('dl_bf_blackfriday_email');
    DLPixelH.capture(eventName, {
      subscribe_email: email,
      current_subscribers_num: parseInt(this.subscribersNum) + 1
    });
    // 实现分享功能
    navigator.clipboard.writeText(baseUrl).then(() => {
      this.showCopySuccessToast();
    });
  }

  showCopySuccessToast() {
    // 创建复制成功提示弹窗
    const toast = document.createElement('div');
    toast.className = 'dl-copy-success-toast';
    toast.innerHTML = `
      <div class="dl-copy-success-toast-content">
        <div class="dl-copy-success-toast-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32.0002" cy="32.0007" r="24.6667" stroke="#0CAC39" stroke-width="4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M48.0949 24.0647L30.8146 41.3452C29.2499 42.9099 26.7121 42.9069 25.1511 41.3385L15.9023 32.046L18.7374 29.2243L27.9862 38.5168L45.2665 21.2363L48.0949 24.0647Z" fill="#0CAC39"/>
          </svg>
        </div>
        <div class="dl-copy-success-toast-text">
          <div class="dl-copy-success-toast-title">${this.copySuccessText || 'The link is copied and ready to share.'}</div>
        </div>
      </div>
    `;

    // 添加到页面
    document.body.appendChild(toast);

    // 显示动画
    setTimeout(() => {
      toast.classList.add('show');
    }, 10);

    // 3秒后自动隐藏
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        if (document.body.contains(toast)) {
          document.body.removeChild(toast);
        }
      }, 300);
    }, 3000);
  }
}
customElements.define('dl-bf-newsletter-success-pop-m', DlBfNewsletterSuccessPopM);
